// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__B9N6K","left":"InfoRow_left__3KebQ"};